import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/layout'

import storage from 'good-storage'
const GROUPID =
  storage.get('net-group-id') &&
  storage.get('net-group-id').toUpperCase() + '01'

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true,
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/403'),
    hidden: true,
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true,
  },
]
export const asyncRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/supervisorLanding/' + GROUPID,
    name: 'home',
    meta: {
      title: 'supervisorLanding',
    },
    children: [
      {
        path: '/supervisorLanding/:id',
        name: 'supervisorLanding',
        component: () => import('@/views/supervisorLanding/index'),
        meta: {
          title: 'supervisorLandingIndex',
          // checkUrlType: 1, // 1:path,2:fullPath
        },
      },
      {
        path: 'ttChart',
        name: 'ttChart',
        component: () => import('@/views/supervisorLanding/tt-chart'),
        meta: {
          title: 'TT Chart',
          checkUrlType: 2,
        },
      },
      {
        path: 'swip-list',
        name: 'swip-list',
        component: () => import('@/views/supervisorLanding/swip-list'),
        meta: {
          title: 'WIP List',
        },
      },
      {
        path: 'nc-job-list',
        name: 'nc-job-list',
        component: () => import('@/views/supervisorLanding/nc-job-list'),
        meta: {
          title: 'Non Conformance List',
          checkUrlType: 2,
        },
      },
      {
        path: 'lost-hour-region',
        name: 'lost-hour-region',
        component: () => import('@/views/supervisorLanding/lost-hour-region'),
        meta: {
          title: 'Lost Hour by Region/Andon Category',
          checkUrlType: 2,
        },
      },

      {
        path: 'not-completed-job-list',
        name: 'not-completed-job-list',
        component: () =>
          import('@/views/supervisorLanding/not-completed-job-list'),
        meta: {
          title: 'Closed Job List',
          checkUrlType: 2,
        },
      },
      {
        path: 'lost-hour-list',
        name: 'lost-hour-list',
        component: () => import('@/views/supervisorLanding/lost-hour-list'),
        meta: {
          title: 'Lost Hour Report',
          checkUrlType: 2,
        },
      },
      {
        path: 'bom',
        name: 'bom',
        component: () => import('@/views/master-data-maintenance/bom'),
        meta: {
          title: 'Work Station BOM Maintenance',
          checkUrlType: 1,
        },
      },
      {
        path: 'group',
        name: 'group',
        component: () => import('@/views/master-data-maintenance/group'),
        meta: {
          title: 'Work Station Group Maintenance',
          checkUrlType: 1,
        },
      },
      {
        path: 'calendar',
        name: 'calendar',
        component: () => import('@/views/master-data-maintenance/calendar'),
        meta: {
          title: 'Calendar',
          checkUrlType: 1,
        },
      },
      {
        path: 'master',
        name: 'master',
        component: () => import('@/views/master-data-maintenance/master'),
        meta: {
          title: 'Master Data',
          checkUrlType: 1,
        },
      },
      {
        path: 'tx-bom',
        name: 'txBom',
        component: () => import('@/views/master-data-maintenance/tx-bom'),
        meta: {
          title: 'Work Request BOM Maintenance',
        },
      },
      {
        path: 'tag-registration',
        name: 'tagRegistration',
        component: () => import('@/views/system-maintenance/tag-registration'),
        meta: {
          title: 'Tag Registration',
        },
      },
      {
        path: '/diagnose-recovery/reset-scan',
        name: 'resetTagId',
        component: () => import('@/views/system-maintenance/reset-scan'),
        meta: {
          title: 'Reset TagId',
        },
      },
      {
        path: '/scan',
        name: 'scan',
        component: () => import('@/views/system-maintenance/scan'),
        meta: {
          title: 'RFID Scan',
        },
      },
      {
        path: '/diagnose-recovery/close-request',
        name: 'closeRequest',
        component: () => import('@/views/system-maintenance/close-request'),
        meta: {
          title: 'Close main station request',
        },
      },
      {
        path: '/diagnose-recovery/close-all-open',
        name: 'close-all-open',
        component: () => import('@/views/system-maintenance/close-all-open'),
        meta: {
          title: 'Close all open work request',
        },
      },
      {
        path: '/mass-change',
        name: 'mass-change',
        component: () => import('@/views/scheduling/components/mass-change'),
        meta: {
          title: 'Work Calendar Mass Change',
          checkUrlType: 2,
        },
      },
      {
        path: '/scheduling',
        name: 'scheduling',
        component: () => import('@/views/scheduling/index'),
        meta: {
          title: 'Job scheduling',
        },
        children: [
          {
            path: 'upload',
            name: 'schedulingUpload',
            component: () => import('@/views/scheduling/upload'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'leveling',
            name: 'schedulingLeveling',
            component: () => import('@/views/scheduling/leveling'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'releveling',
            name: 'schedulingReleveling',
            component: () => import('@/views/scheduling/releveling'),
          },
          {
            path: 'progress',
            name: 'schedulingProgress',
            component: () => import('@/views/scheduling/progress'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'adjustment',
            name: 'schedulingAdjustment',
            component: () => import('@/views/scheduling/adjustment'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'scheduling-master/home',
            name: 'schedulingMasterHome',
            component: () => import('@/views/scheduling/master-data'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'schedulingIndex/home',
            name: 'schedulingIndexHome',
            component: () => import('@/views/scheduling/scheduling-home'),
            meta: {
              checkUrlType: 3,
              checkUrl: '/scheduling/scheduling-schedulingIndex/home',
            },
          },
          {
            path: 'scheduling-schedulingIndex',
            name: 'schedulingIndex',
            component: () => import('@/views/scheduling/simulation'),
          },
        ],
      },
      {
        path: '/shipment',
        name: 'shipment',
        component: () => import('@/views/shipment/index'),
        meta: {
          title: 'Shipment Window',
        },
        children: [
          {
            path: 'master/master',
            name: 'shipmentMasterHome',
            component: () => import('@/views/shipment/master-home'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'master-data',
            name: 'shipmentMasterData',
            component: () => import('@/views/shipment/master-data'),
          },
          {
            path: 'upload',
            name: 'shipmentUpload',
            component: () => import('@/views/shipment/upload'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'preLeveling',
            name: 'shipmentPreLeveling',
            component: () => import('@/views/shipment/pre-leveling'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'progress',
            name: 'shipmentProgress',
            component: () => import('@/views/shipment/progress'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'input',
            name: 'shipmentInput',
            component: () => import('@/views/shipment/input'),
            meta: {
              checkUrlType: 1,
            },
          },
          {
            path: 'adjustment',
            name: 'shipmentAdjustment',
            component: () => import('@/views/shipment/adjustment'),
            meta: {
              checkUrlType: 1,
            },
          },
        ],
      },
      {
        path: '/internal-logistics-dashboard',
        name: 'internalLogisticsDashboard',
        component: () => import('@/views/internal-logistics-dashboard/index'),
        meta: {
          title: 'internalLogisticsDashboard',
        },
      },
      {
        path: '/eMap',
        name: 'eMap',
        component: () => import('@/views/emap/index'),
        meta: {
          title: 'UWB Tag Map',
          checkUrlType: 1,
        },
      },
      {
        path: '/report-production',
        name: 'report-production',
        component: () => import('@/views/report/production-lead-time'),
        meta: {
          title: 'Production Lead Time',
          checkUrlType: 1,
        },
      },
      {
        path: '/wfi',
        name: 'wfi',
        component: () => import('@/views/report/wfi'),
        meta: {
          title: 'WFI',
          checkUrlType: 1,
        },
      },
      {
        path: '/va-ratio',
        name: 'vaRatio',
        component: () => import('@/views/report/va-ratio'),
        meta: {
          title: 'VA Ratio',
          checkUrlType: 2,
        },
      },
      {
        path: '/fifoCoverageReport',
        name: 'fifoCoverageReport',
        component: () => import('@/views/report/fifoCoverageReport'),
        meta: {
          title: 'FIFO Coverage Report',
        },
      },
      {
        path: '/andon-category-tab',
        name: 'andon-category-tab',
        component: () =>
          import('@/views/master-data-maintenance/andon-category-tab'),
        meta: {
          title: 'Andon Category',
        },
      },
      {
        path: '/andon-event-code',
        name: 'andon-event-code',
        component: () =>
          import('@/views/master-data-maintenance/andon-event-code'),
        meta: {
          title: 'Andon Event Code',
        },
      },
      {
        path: '/andonOverview/:id',

        name: 'andonOverview',
        component: () => import('@/views/andon-overview/index'),
        meta: {
          title: 'andonOverviewIndex',
          checkUrlType: 1,
        },
      },
      {
        path: '/workStation/:id',
        name: 'workStation',
        component: () => import('@/views/workStation/index'),
        meta: {
          title: 'Assy Workstation',
          checkUrlType: 1,
        },
      },
      {
        path: '/manual/:regionCode',
        name: 'manual',
        component: () => import('@/views/manual/index'),
        meta: {
          title: 'Manual WorkStation',
          checkUrlType: 1,
        },
      },
      {
        path: '/operatorAndon/:regionCode',
        name: 'operatorAndon',
        component: () => import('@/views/operatorAndon/index'),
        meta: {
          title: 'Andon List',
          checkUrlType: 1,
        },
      },
      {
        path: '/staging/:regionCode',
        name: 'staging',
        component: () => import('@/views/staging/index'),
        meta: {
          title: 'Staging',
          checkUrlType: 1,
        },
      },
      {
        path: '/fifo/:regionCode',
        name: 'fifo',
        component: () => import('@/views/fifo/index'),
        meta: {
          title: 'FIFO Lane',
          checkUrlType: 1,
        },
      },
      {
        path: '/fifo-init/:regionCode',
        name: 'fifoInit',
        component: () => import('@/views/fifo/fifo-init'),
        meta: {
          title: 'Stock Registration',
          checkUrlType: 1,
        },
      },
      {
        path: '/fifo-de-registration/:regionCode',
        name: 'fifoDeRegistration',
        component: () => import('@/views/fifo/fifo-de-registration'),
        meta: {
          title: 'Stock De-Registration',
        },
      },
      {
        path: '/supermarket/:regionCode',
        name: 'supermarket',
        component: () => import('@/views/supermarket/index'),
        meta: {
          title: 'Supermarket Task List',
          checkUrlType: 1,
        },
      },
      {
        path: '/supermarketDetail/:pickId',
        name: 'supermarketDetail',
        component: () => import('@/views/supermarket/detail'),
        meta: {
          title: 'Task Detail',
          checkUrlType: 1,
        },
      },
      {
        path: '/delivery-tracking',
        name: 'delivery-tracking',
        component: () => import('@/views/delivery-tracking/index'),
        meta: {
          title: 'BJHC Porducts Delivery Tracking',
        },
      },
      {
        path: '/kanban-vendor',
        name: 'kanbanVendor',
        component: () => import('@/views/vendor-kanban/index'),
        meta: {
          title: 'FIFO',
        },
      },
    ],
  },

  {
    path: '/vendor',
    component: Layout,
    name: 'vendor',
    beforeEnter: () => {
      window.location.href = '/vendor/'
    },
  },
  {
    path: '/user',
    component: Layout,
    name: 'user',
    beforeEnter: () => {
      window.location.href = '/user/'
    },
  },
  {
    path: '/tj-precool',
    component: Layout,
    name: 'tjPrecool',
    beforeEnter: () => {
      window.location.href = '/tj-precool/'
    },
  },
  {
    path: '/delivery-management',
    component: Layout,
    name: 'deliveryManagement',
    beforeEnter: () => {
      window.location.href = '/delivery/management/'
    },
  },

  //vue3对404配置进行了修改, 必须要使用正则匹配
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
    hidden: true,
  },
]
const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes,
})

export default router
